<template>
  <div class="meeting">
    <div class="meetingDiv">
     <!--  <div class="meetingImgDiv">
        <img :src="this.meeting.img" alt="分会图片" class="meetingImg" />
        <div class="joinBtnDiv">
          <button class="joinBtn" v-if="this.meeting.status == 0" @click="joinmeeting">
            加入分会
          </button>
          <button class="outBtn" v-if="this.meeting.status == 1" @click="quitMeeting">
            退出分会
          </button>
        </div>
      </div> -->
      <div class="nameAndBtn">
      <div class="meetingName">{{ this.meeting.title }}</div>
      <div class="joinBtnDiv">
          <button class="joinBtn" v-if="this.meeting.status == 0" @click="joinmeeting">
            加入分会
          </button>
          <button class="outBtn" v-if="this.meeting.status == 1" @click="quitMeeting">
            退出分会
          </button>
        </div>
      </div>
      <!-- <div class="meetingBuildDate">
        成立时间：{{ this.meeting.establishTime }}
      </div>
      <div class="meetingPresident">会长：{{ this.meeting.mastorName }}</div>
      <div class="meetingSecretaryGeneral">
        秘书长：{{ this.meeting.secretaryName }}
      </div>
      <div class="meetingTelDiv clearfix">
        <div class="meetTelName">联系人：{{ this.meeting.contacts }}</div>
        <div class="meetingTelIconDiv">
          <a :href="this.meeting.phone">
            <img src="../../assets/image/btn_dianhua_nor.png" alt="电话" class="meetingTelIcon" />
          </a>
        </div>
      </div>
      <div class="meetingEmail">邮箱：{{ this.meeting.email }}</div> -->
    </div>
   <!--  <div class="hrDiv"></div> -->
    <div class="meetingAlumni">
      <div class="titleDiv clearfix">
        <div class="titleIcon"></div>
        <div class="titleWord">分会成员</div>
        <button class="activeMore" @click="gotoMeetingMember">更多</button>
      </div>
      <div class="alumnusDiv">
        <template v-if="alumnus.length > 0">
          <template v-for="item in alumnus" class="alumni-card-box">
            <alumni-info-card :info="item" @go="gotoAlumnusDetail(item.userId)"/>
          </template>
        </template>
<!--        <div class="clearfix" style="width: 170vw">-->
<!--          <div class="alumnusDisplay" v-for="item in alumnus" :key="item.id"-->
<!--            @click="gotoAlumnusDetail(item.userId)">-->
<!--            <img :src="item.url" alt="校友照片" class="alumnusDisplayImg" />-->
<!--            <div class="sexDiv" v-if="item.sex == 1">-->
<!--              <img src="../../assets/image/btn_nan_nor.png" alt="性别男" class="sex" />-->
<!--            </div>-->
<!--            <div class="sexDiv" v-else>-->
<!--              <img src="../../assets/image/btn_nv_nor.png" alt="性别女" class="sex" />-->
<!--            </div>-->
<!--            <div class="alumnusDisplayAdress">{{ item.city }}</div>-->
<!--            <div class="nameAndDissertation clearfix">-->
<!--              <div class="alumnusDisplayName">{{ item.name }}</div>-->
<!--              <div class="alumnusDisplayDissertation">-->
<!--                {{ item.xuejie }}-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="alumnusDisplayResources">-->
<!--              资源：{{ item.industry }}-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
    <!-- <div class="hrDiv"></div>
    <div class="alumnusHome">
      <div class="titleDiv clearfix">
        <div class="titleIcon"></div>
        <div class="titleWord">校友之家</div>
      </div>
      <div class="alumnusHomeCard" v-for="item in this.meeting.schoolHome" :key="item.id">
        <div class="alumnusHomeImgDiv">
          <img :src="item.url" alt="校友之家" class="alumnusHomeImg" />
          <div class="imgTipDiv">
            <img src="../../assets/image/btn_lan_nor.png" alt="标签" class="imgTip" />
            <div class="tipId">编号：{{ item.id }}</div>
          </div>
          <div class="profiles">&nbsp;&nbsp;{{ item.service }}</div>
        </div>
        <div class="card">
          <div class="alumnusHomeName">{{ item.name }}</div>
          <div class="alumnusAndTel clearfix">
            <div class="alumnus">校友：{{ item.contact }}</div>
            <div class="telDiv">
              <a :href="'tel' + ':' + item.telephone">
                <img src="../../assets/image/btn_dianhua_nor.png" alt="联系" class="tel" />
              </a>
            </div>
          </div>
          <div class="adress">地址：{{ item.address }}</div>
          <div class="wechat">微信：{{ item.wechat }}</div>
        </div>
      </div>
    </div>
    <div class="hrDiv"></div>
    <div class="swipe">
      <div class="titleDiv clearfix">
        <div class="titleIcon"></div>
        <div class="titleWord">微信群</div>
      </div>
      <div class="swipeCard">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="#00706E">
          <van-swipe-item v-for="(image, index) in this.meeting.qrCode" :key="index">
            <img :src="image" alt="轮播图" class="swipeImg" />
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <div class="hrDiv"></div>
    <div class="alumnusProfilesDiv">
      <div class="titleDiv clearfix">
        <div class="titleIcon"></div>
        <div class="titleWord">{{ this.meeting.name }}介绍</div>
      </div>
      <div class="alumnusProfiles">
        <div class="alumnusProfilesWord" id="alumnusProfilesWordId"></div>
      </div>
    </div> -->
  </div>
</template>
<script>
import AlumniInfoCard from "../alumniResources/components/AlumniInfoCard/index.vue";
import Base64 from "@/utils/base64";
export default {
  components: {AlumniInfoCard},
  data() {
    return {
      meeting: "",
      contactsTel: "",
      alumnus: "",
      alumniHome: "",
      swipe: [],
    };
  },
  created() {
    this.getMeeting();
    //this.getAlumnus();
  },
  methods: {
    async getMeeting() {
      let base64 = new Base64()
      const result = await this.$http.get("/branch/getBranchInDetail", {
        params: { userId: base64.encode(window.localStorage.getItem("user_id")), schoolBranchId: this.$route.query.schoolBranchId }
      });
      this.meeting = result.data;
      //this.alumniHome = result.data.member;
      if (result.data.member != null && result.data.member.length > 0) {
        result.data.member.forEach(item => {
          item.aUserId = item.userId
          item.aUrl = item.url
          item.aName = item.name
          item.aDanWei = item.danwei
          item.aCollege = item.college
          item.amajor = item.major
          item.aXuejie = item.xuejie
          item.aprovince = item.province
          item.aCity = item.city
          item.isExchange = false
          item.aphone = item.phone
          return item
        })
        this.alumnus = result.data.member.slice(0,4);
      }
      this.contactsTel = "tel" + ":" + this.meeting.phone;
     /*  document.getElementById("alumnusProfilesWordId").innerHTML =
        this.meeting.content; */
    },
    async joinmeeting() {
      const result = await this.$http({
        url: "/branch/joinBranch",
        method: "POST",
        //headers: { "content-type": "application/x-www-form-urlencoded" },
        data: {
            userId: parseInt(window.localStorage.getItem("user_id")),
            schoolBranchId: parseInt(this.$route.query.schoolBranchId),
            id: parseInt(this.$route.query.schoolBranchId),
        },
      });
      if (result.data.success == true) {
        this.$toast("加入成功");
        location.reload();
      } else {
        this.$toast(result.data.msg);
      }
    },
    async quitMeeting() {
      const result = await this.$http({
        url: "/branch/quitBranch",
        method: "GET",
        //headers: { "content-type": "application/x-www-form-urlencoded" },
        params: {
          userId: parseInt(window.localStorage.getItem("user_id")),
          schoolBranchId: parseInt(this.$route.query.schoolBranchId)
        },
      });
      if (result.data.success == true) {
        this.$toast("退出成功");
        location.reload();
      } else {
        this.$toast(result.data.msg);
      }
    },
    gotoMeetingMember() {
      return this.$router.push({
        path: "/meetingMember",
        query: { bid: this.$route.query.schoolBranchId },
      });
    },
    gotoAlumnusDetail(userId) {
      if (userId === window.localStorage.getItem("user_id")) {
        return this.$router.push("/myCard");
      }
      return this.$router.push({
        path: "/alumniDetailNew",
        query: { alumniId: userId }
      })
    },
  },
};
</script>
<style lang="less" scoped>
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  *zoom: 1;
}

.meeting {
  position: relative;
}

.meetingDiv {
  position: relative;
  left: 5%;
  width: 90%;

  .meetingImgDiv {
    position: relative;
    width: 100%;
    height: 23vh;

    .meetingImg {
      width: 100%;
      height: 100%;
      border-radius: 15px;
    }
  }

  .nameAndBtn {
    display: flex;
    justify-content: space-between;
  .meetingName {
    margin-top: 15px;
    font-size: 1.4rem;
    font-weight: bold;
    color: #333333;
  }

  .joinBtnDiv {
    margin-top: 15px;
      .joinBtn, .outBtn {
        border: 0;
        border-radius: 20px;
        color: white;
        font-size: 1rem;
        padding: 5px 15px;
      }
      .joinBtn {
        background: linear-gradient(270deg, #00706E, #00706E);
      }
      .outBtn {
        background: linear-gradient(270deg, #fd4545, #fb6f6f);
      }
    }

}
  .meetingBuildDate,
  .meetingPresident,
  .meetingSecretaryGeneral,
  .meetingEmail {
    margin: 5px 0px 5px 10px;
    font-size: 1.13rem;
    font-weight: bold;
    color: #666666;
  }

  .meetingTelDiv {
    position: relative;
    margin: 5px 0px 5px 10px;
    font-size: 1.13rem;
    font-weight: bold;
    color: #666666;

    .meetTelName {
      float: left;
    }

    .meetingTelIconDiv {
      float: left;
      width: 1em;
      margin-left: 10px;

      .meetingTelIcon {
        width: 100%;
      }
    }
  }
}

.hrDiv {
  margin-top: 15px;
  width: 100%;
  height: 5px;
  background: #e7e7e7;
}

.titleDiv {
  position: relative;
  margin-left: 5%;
  height: 7vw;
  width: 90%;
  margin-top: 20px;

  .titleIcon {
    float: left;
    width: 4px;
    height: 6vw;
    background-color: #00706E;
    border-radius: 15px;
  }

  .titleWord {
    float: left;
    padding-left: 10px;
    font-size: 1.3em;
    font-weight: bold;
    color: #333333;
  }

  .activeMore {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    float: right;
    color: #00706E;
    border: 0;
    background: #f5f5f5;
  }
}

.alumnusDiv {
  position: relative;
  left: 5%;
  width: 90%;
  padding-top: 5px;
  overflow-x: scroll;
  overflow-y: hidden;
}

.alumnusDiv::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}

.alumnusDisplay {
  position: relative;
  width: 22.5%;
  height: 38vw;
  margin: 0 5px;
  white-space: nowrap;
  border-radius: 15px;
  float: left;
  background-color: white;
  border: 1px solid #e1e1e1;
}

.alumnusDisplayImg {
  width: 33%;
  height: 12.6vw;
  border-radius: 999px;
  position: absolute;
  left: 50%;
  top: 10%;
  transform: translateX(-50%);
}

.sexDiv {
  position: absolute;
  left: 60%;
  top: 10%;
}

.sex {
  width: 15px;
  height: 15px;
}

.alumnusDisplayAdress {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translateX(-50%);
  color: #00706E;
  font-size: 0.9em;
}

.nameAndDissertation {
  position: absolute;
  width: 65%;
  top: 60%;
  left: 50%;
  transform: translateX(-50%);
}

.alumnusDisplayName {
  float: left;
}

.alumnusDisplayDissertation {
  float: right;
  font-size: 0.9em;
  color: #666666;
}

.alumnusDisplayResources {
  position: absolute;
  font-size: 0.9em;
  color: #666666;
  top: 70%;
  text-align: center;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: pre-line;
}

.alumnusHome {
  .alumnusHomeCard {
    position: relative;
    left: 5%;
    width: 90%;
    margin: 10px 0 20px 0;

    .alumnusHomeImgDiv {
      position: relative;
      width: 100%;
      height: 20vh;

      .alumnusHomeImg {
        width: 100%;
        height: 100%;
        border-radius: 15px 15px 0 0;
      }

      .imgTipDiv {
        position: absolute;
        left: 0%;
        top: 0%;
        width: 30%;

        .imgTip {
          width: 100%;
          border-radius: 15px 0;
        }

        .tipId {
          position: absolute;
          left: 50%;
          top: 45%;
          transform: translate(-50%, -50%);
          font-weight: 400;
          color: #ffffff;
          font-size: 1rem;
          white-space: nowrap;
        }
      }

      .profiles {
        position: absolute;
        bottom: 0%;
        width: 100%;
        background-color: #000000;
        opacity: 0.6;
        color: white;
        padding: 5px 0;
      }
    }

    .card {
      width: 100%;
      border: 1px solid #e1e1e1;
      border-radius: 0 0 15px 15px;

      .alumnusHomeName {
        margin: 15px 5px;
        font-weight: bold;
        color: #333333;
        font-size: 1.3rem;
      }

      .alumnusAndTel {
        margin: 0 0 10px 5px;
        font-weight: 400;
        color: #666666;
        font-size: 1rem;

        .alumnus {
          float: left;
        }

        .telDiv {
          float: left;
          margin-left: 10px;

          .tel {
            width: 1em;
          }
        }
      }

      .adress,
      .wechat {
        margin: 0 0 10px 5px;
        font-weight: 400;
        color: #666666;
        font-size: 1rem;
      }
    }
  }
}

.swipe {
  position: relative;

  .swipeCard {
    position: relative;
    left: 5%;
    width: 90%;
    margin: 10px 0 0px 0;
    background: #ffffff;
    border: 1px solid #e1e1e1;
    border-radius: 15px;

    .my-swipe {
      .van-swipe-item {
        position: relative;

        .swipeImg {
          position: relative;
          left: 50%;
          transform: translateX(-50%);
          margin: 60px 0 50px 0;
          height: 33vw;
          width: 33vw;
        }

        .swipeTitle {
          position: absolute;
          left: 50%;
          top: 20px;
          transform: translateX(-50%);
          font-size: 1.2rem;
          font-weight: bold;
          color: #333333;
        }

        .swipeDescribe {
          position: absolute;
          left: 50%;
          bottom: 25px;
          transform: translateX(-50%);
          font-size: 1.1rem;
          font-weight: 400;
          color: #333333;
        }
      }
    }
  }
}

.alumnusProfilesDiv {
  position: relative;

  .alumnusProfiles {
    position: relative;
    left: 5%;
    width: 90%;
    margin: 10px 0;
    background: #ffffff;
    border: 1px solid #e1e1e1;
    border-radius: 15px;

    .alumnusProfilesWord {
      position: relative;
      left: 3%;
      width: 94%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/alumniMeeting/MeetingDetails.vue